import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonInput, IonSlides, LoadingController, ModalController, Platform} from '@ionic/angular';
import {Observable, Subject, Subscription} from 'rxjs';
import * as apiVeranstaltungen from './../../../../clients/veranstaltungen';
import * as fromVeranstaltungenPage from './veranstaltungen-aktionen.reducer';
import {Settings} from '@orga-app/settings/settings.model';
import {select, Store} from '@ngrx/store';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {WindowRefService} from '@orga-app/providers/window.service';
import {UuidService} from '@orga-app/providers/uuid.service';
import {SafeUrl} from '@angular/platform-browser';
import {
    PageStateResetAction
} from './veranstaltungen-aktionen.actions.ui';
import {ActivatedRoute, Router} from '@angular/router';
import {expandCollapsiblePanelAnimation} from '../../../../sopi/animations';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {
    getVeranstaltungAktionen, getVeranstaltungAktionenList
} from './veranstaltungen-aktionen.selectors';
import {Aktion, VeranstaltungBerechtigung} from '../../../../clients/veranstaltungen';
import {GetVeranstaltungAktionenAdminAction, PostVeranstaltungAktionEntfernenAction, PostVeranstaltungAktionErfassenAction, PostVeranstaltungAktionReihenfolgeSetzenAction} from '../../../../client-ngrx/veranstaltungen';

@Component({
    selector: 'app-veranstaltungen-aktionen',
    templateUrl: './veranstaltungen-aktionen.page.html',
    styleUrls: ['./veranstaltungen-aktionen.page.scss'],
    animations: [
        expandCollapsiblePanelAnimation
    ]
})
export class VeranstaltungenAktionenPage implements OnInit, OnDestroy {
    @ViewChild(IonSlides, {static: false}) slides: IonSlides;
    @ViewChild('aktionTitelInput', {static: false}) aktionTitelInput: IonInput;

    @Input() aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    @Input() berechtigung$: Observable<VeranstaltungBerechtigung>;

    collapsiblePanelOpen = 'open';
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    windowLocal: Window;
    aiName = 'VeranstaltungenPage';
    alive = true;

    subscriptionVeranstaltung: Subscription;
    subscriptionAktionen: Subscription;
    aktuelleVeranstaltungId: string;

    aktionenTab = 'editieren';
    aktuelleAktion: Aktion;
    aktionen$: Observable<Array<ListInputItem>>;
    aktionenList$: Observable<Array<Aktion>>;
    aktionen: Array<Aktion>;
    uiEditing = false;
    uiEditingText = 'sortieren';

    de: any;
    setFocus = false;
    public sectionAktionPreviewIstOffen = true;

    private unsubscribe$ = new Subject();

    checkShowTabbedMdPreview = true;

    constructor(
        public modalCtrl: ModalController,
        public loadingCtrl: LoadingController,
        private windowRefService: WindowRefService,
        private uuid: UuidService,
        public alertCtrl: AlertController,
        public element: ElementRef,
        private store: Store<fromVeranstaltungenPage.PageState>,
        public settingsProvider: SettingsProvider,
        public platform: Platform,
        public route: ActivatedRoute,
        public router: Router) {

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
    }

    reorderItems(items, from, to) {
        const element = items[from];
        items.splice(from, 1);
        items.splice(to, 0, element);
        return items;
    }

    async toggleEditAktionen() {
        this.uiEditing = !this.uiEditing;
        if (this.uiEditing) {
            this.uiEditingText = 'fertig';
        } else {
            this.uiEditingText = 'sortieren';
        }
    }

    async reorderAktionen(event: { from: number, to: number }) {
        let aktionenIds = this.aktionen.map(x => x.aktion_id);
        aktionenIds = this.reorderItems(aktionenIds, event.from, event.to);

        const veranstaltungAktionReihenfolgeSetzenMultiRequest = <apiVeranstaltungen.AktionReihenfolgeSetzenMultiRequest>{
            aktion_ids: aktionenIds,
            veranstaltung_id: this.aktuelleVeranstaltungId,
            zeitpunkt_utc: new Date()
        };

        this.store.dispatch(new PostVeranstaltungAktionReihenfolgeSetzenAction(veranstaltungAktionReihenfolgeSetzenMultiRequest));
    }


    // ionViewDidLoad() {
    ngOnInit() {
        const w = document.documentElement.clientWidth;
        const breakpoint = 1430;
        this.checkShowTabbedMdPreview = w < breakpoint;

        this.windowLocal = this.windowRefService.nativeWindow;
        this.uiEditingText = 'sortieren';

        this.aktionen$ = this.store.pipe(select(getVeranstaltungAktionen));
        this.aktionenList$ = this.store.pipe(select(getVeranstaltungAktionenList));

        if (this.aktionenList$) {
            this.subscriptionAktionen = this.aktionenList$.subscribe((x: Array<Aktion>) => {
                if (x !== null && x !== undefined) {
                    this.aktionen = x;
                }
            });
        }

        if (this.aktuelleVeranstaltung$ !== undefined) {
            this.subscriptionVeranstaltung = this.aktuelleVeranstaltung$.subscribe((x: apiVeranstaltungen.Veranstaltung) => {
                if (x !== null) {
                    this.aktuelleVeranstaltungId = x.veranstaltung_id;

                    // Aktuell selektierte aktion gegen neue ersetzen, da sich die Reihenfolge geändert haben könnte
                    if (this.aktuelleAktion !== undefined && this.aktuelleAktion !== null) {
                        const resAktionen = this.aktionen.find((y: apiVeranstaltungen.Aktion) => {
                            return y.aktion_id === this.aktuelleAktion.aktion_id;
                        });
                        if (resAktionen) {
                            this.aktuelleAktion = Object.assign({}, resAktionen);
                        }
                    }
                    this.store.dispatch(new GetVeranstaltungAktionenAdminAction(this.aktuelleVeranstaltungId));

                }
            });
        }
    }


    ngOnDestroy(): void {
      this.unsubscribe$.complete();
      if (this.subscriptionAktionen) {
          this.subscriptionAktionen.unsubscribe();
      }
      if (this.subscriptionVeranstaltung) {
          this.subscriptionVeranstaltung.unsubscribe();
      }
  }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new PageStateResetAction());
        await this.aktionenLaden();
    }

    async aktionenLaden() {
        this.store.dispatch(new GetVeranstaltungAktionenAdminAction(this.aktuelleVeranstaltungId));
    }


    async aktionAuswaehlen(aktion: apiVeranstaltungen.Aktion) {
        if (aktion !== null && aktion.aktion_id !== null) {
            this.aktuelleAktion = Object.assign({}, aktion);

            setTimeout(() => {
                if (this.aktionTitelInput) {
                    this.aktionTitelInput.setFocus();
                }
            }, 200);
        }
    }

    async aktionSpeichern() {
        if (this.aktuelleAktion !== null) {
            const request = <apiVeranstaltungen.AktionDataRequest>{
                aktion_id: this.aktuelleAktion.aktion_id,
                veranstaltung_id: this.aktuelleVeranstaltungId,
                info_text: this.aktuelleAktion.info_text,
                reihenfolge: this.aktuelleAktion.reihenfolge,
                titel: this.aktuelleAktion.titel,
                zeitpunkt_utc: new Date()
            };

            this.store.dispatch(new PostVeranstaltungAktionErfassenAction(request));
        }
    }

    async aktionAbbrechen() {
        this.aktuelleAktion = null;
    }

    async neueAktionAnlegen() {
        this.aktuelleAktion = <apiVeranstaltungen.Aktion>{
            aktion_id: this.uuid.generateUUID(),
            info_text: '',
            titel: ''
        };
        setTimeout(() => {
            if (this.aktionTitelInput) {
                this.aktionTitelInput.setFocus();
            }
        }, 200);
    }

    async aktionEntfernen(aktion: apiVeranstaltungen.Aktion) {
        if (aktion !== null) {
            const request = <apiVeranstaltungen.AktionRequest>{
                aktion_id: aktion.aktion_id,
                veranstaltung_id: this.aktuelleVeranstaltungId,
                zeitpunkt_utc: new Date()
            };

            this.store.dispatch(new PostVeranstaltungAktionEntfernenAction(request));
            this.aktuelleAktion = null;
        }
    }

    async toggleSectionAktionPreview() {
        this.sectionAktionPreviewIstOffen = !this.sectionAktionPreviewIstOffen;
    }

    insertTextAtPosition($event, insertText = '[Text](https://website.de)') {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        const value = textArea.value;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;

        textArea.value = value.slice(0, start) + insertText + value.slice(end);

        this.aktuelleAktion.info_text = textArea.value;

        // textArea.selectionStart = textArea.selectionEnd = start + insertText.length;
        textArea.selectionStart = textArea.selectionEnd = start + 1;

        textArea.focus();
    }

    insertTextAtPositionNewTab($event, insertText = '<a href="https://webseite.de/" target="_blank">Text</a>') {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        const value = textArea.value;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;

        textArea.value = value.slice(0, start) + insertText + value.slice(end);

        this.aktuelleAktion.info_text = textArea.value;

        textArea.selectionStart = textArea.selectionEnd = start + 1;

        textArea.focus();
    }
}
